import { Component, inject, input, model, output, signal } from '@angular/core';
import { ProfileService } from '../../profile/services/profile.service';
import { UserService } from '../services/user.service';
import { TableModule } from 'primeng/table';
import { ImageModule } from 'primeng/image';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { Role } from '../../shared/enum/role.enum';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { TagModule } from 'primeng/tag';
import { IconFieldModule } from 'primeng/iconfield';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule } from '@angular/common';
import { RoutesService } from '../../shared/services/routes.service';
import { CardModule } from 'primeng/card';
import { AccessModel } from '../../core/models/access.model';
import { RippleModule } from 'primeng/ripple';
import { AccessService } from '../../core/services/access.service';
import { ResourceFormCardComponent } from "../../shared/components/resource-form-card/resource-form-card.component";
import { ResourceButtonGroupComponent } from "../../shared/components/resource-button-group/resource-button-group.component";
import { User, Users } from '../models/user.model';
import { UsersInterface } from '../interfaces/user.interface';

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [
    TableModule,
    ImageModule,
    ButtonModule,
    ButtonGroupModule,
    ChipModule,
    InputTextModule,
    InputIconModule,
    TableModule,
    TagModule,
    IconFieldModule,
    MultiSelectModule,
    DropdownModule,
    CommonModule,
    CardModule,
    RippleModule,
    ResourceFormCardComponent,
    ResourceButtonGroupComponent
],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.css'
})
export class UserListComponent {
  protected service = inject(UserService)
  protected routesService = inject(RoutesService)
  protected profile = inject(ProfileService).profile
  protected access = inject(AccessService).access

  resource = this.service.resource;
  roleEnum = Role

  detailed = input<boolean>(true);

  value = this.service.users

  length = output<number>()

  ngOnInit(): void {
    this.service.title.update((value) => 'Lista de Usarios')
    this.service.get().subscribe(data => {
      this.value.update(users => {
        users = (data as UsersInterface).map((user) => new User(user));
        this.length.emit(users.length)
        return users;
      });
    })
  }

  name(event: any) {
    console.log('Evento de carga diferida: ',event)
  }
}
